import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetCart } from "../../../Redux/features/WebRegister/cartSlice";
import { fmt } from "../uiUtils";

// Cart footer (POS right panel): Customer, then Cancel + "Pay (N Items) $total". The order-level
// action buttons (Custom Item / Discounts / Coupons / OTD) live in the home ActionColumn, per POS.
//
// Cancel is deliberately NOT styled as a peer of Pay: it wipes the sale. It keeps a smaller,
// quieter, ghost treatment and sits away from the thumb's resting path, while Pay owns the width
// and the colour. Destructive and primary should never look interchangeable on a till.
export default function ActionBar({ onPay, onCustomer, onCancel }) {
  const dispatch = useDispatch();
  const { lines, totals, customer } = useSelector((st) => st.webRegisterCart);
  const empty = lines.length === 0;
  const itemCount = lines.reduce((sum, l) => sum + (Number(l.orderCount) || 0), 0);

  const cancel = () => {
    dispatch(resetCart());
    if (onCancel) onCancel();
  };

  return (
    <div className="qv-cart-foot">
      <button className="qv-btn qv-btn--ghost" onClick={onCustomer} title="Attach or add a customer">
        {customer ? "👤 Customer ✓" : "Customer"}
      </button>
      <button className="qv-btn qv-btn--danger" disabled={empty} onClick={cancel} title="Clear this sale">
        Cancel
      </button>
      <button
        className="qv-btn qv-btn--primary qv-pay qv-btn--block"
        disabled={empty}
        onClick={() => (empty ? null : onPay())}
      >
        Pay ({itemCount} Item{itemCount === 1 ? "" : "s"}) <span className="qv-num">{fmt(totals.display ? totals.display.payAmount : totals.grandTotal)}</span>
      </button>
    </div>
  );
}
